import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { NavLink, useNavigate } from 'react-router-dom';
import { Row, Col, CardBody, Card } from "reactstrap";
import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../components/Loaders/DnaLoader";
import DataTable from 'react-data-table-component';
import DiscountCouponService from "../DiscountCoupon/Discountcoupons.service";
import AuthService from "../Authentication/auth.service";
import Alerts from "../../components/Alerts/alerts";
import { Tooltip } from "@mui/material";
import DiscountCouponsFilter from "../../components/Table Filters/DoctorLadgerFilter.js";
import PermissionAccess from '../../PermissionAccess/Access.js';
import moment from "moment";
import { downloadLedgerPdf } from "../../utils/ledgerPdfGenerator";

const DiscountcouponsList = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [discountcoupons, setDiscountcoupons] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('');
  const [withDrawlCount, setWithDrawlCount] = useState(0);
  const [selectedId, setSelectedId] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);
  const [pdfDownloadingId, setPdfDownloadingId] = useState(null);

  const [pageLimit, setPageLimit] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const hasPermission = (value) => value === 1 || value === "1" || value === true;
  const canView = super_admin || hasPermission(current_module?.ViewDetails) || hasPermission(current_module?.ViewData);

  const [showModalAddDiscountCoupon, setShowModalAddDiscountCoupon] = useState(false);
  const handleToggleModalAddDiscountCoupon = () => {
    setShowModalAddDiscountCoupon(!showModalAddDiscountCoupon);
  }

  const [showModalEditDiscountCoupon, setShowModalEditDiscountCoupon] = useState(false);
  const handleToggleModalEditDiscountCoupon = (id) => {
    setShowModalEditDiscountCoupon(!showModalEditDiscountCoupon);
    setSelectedId(id); // Set the selected ID when toggling modal
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchDiscountcoupons(0, pageLimit);
  }, [pageLimit]);


  function fetchDiscountcoupons(page_index, page_limit, status) {
    setLoading(true);
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }

    
    DiscountCouponService.getAllDoctorLadgers(authData.sessionID,offset, page_limit, status).then(
      (response) => {
        setLoading(false);
        console.log("Get discountcoupons response:-", response);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          console.log(response.data);
          setDiscountcoupons(response.data.data);
          setWithDrawlCount(response.data.withDrawlCount);
          setTotalRows(response.data.count.count);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        if (errContent) {
          Alerts.swalErrorAlert(errContent);
        } else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."));
        }
      }
    );
  }


  const handleDownloadPdf = async (row) => {
    const doctorName = row.doctor_details?.full_name || t("Service Provider");
    setPdfDownloadingId(row._id);
    try {
      const response = await DiscountCouponService.getDoctorLadgerDetails(
        authData.sessionID,
        0,
        10000,
        "",
        row._id
      );

      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
        return;
      }

      const transactions = response.data.data || [];
      if (!transactions.length) {
        Alerts.swalErrorAlert(t("No transaction data available."));
        return;
      }

      await downloadLedgerPdf({
        data: transactions,
        entityName: doctorName,
        ledgerType: "doctor",
        fileName: `${doctorName.replace(/[^a-zA-Z0-9_-]/g, "_")}_Ledger_${moment().format("YYYY-MM-DD")}.pdf`,
        t,
      });
      Alerts.swalSuccessAlert(t("PDF generated successfully"));
    } catch (error) {
      Alerts.swalErrorAlert(error.message || t("Failed to generate PDF. Please try again."));
    } finally {
      setPdfDownloadingId(null);
    }
  };

  const mycolumns = [
    {
      name: t('Service Provider'),
      selector: row => row.doctor_details?.full_name || "-",
      width: "40%",
      sortable: true,
    },

    {
    name: t('Pending Amount'),
    selector: row => row.total_amount?.toFixed(2) || "0.00",
    width: "30%",
    sortable: true,
    },

    {
  name: t('Actions'),
  width: "30%",
  cell: (row) => canView ? (
    <div className="d-flex gap-2 align-items-center">
      <Tooltip
        placement="top"
        title={`${t("View")} ${t("Details")}`}
        arrow
      >
        <i
          className="pe-7s-look btn-icon-wrapper text-info fs-5 p-1 ViewDetails"
          style={{ cursor: "pointer" }}
          onClick={() =>
            navigate("/ladger-details", {
              state: {
                doctor_ladger_id: row._id,
                doctor_name: row.doctor_details?.full_name,
                doctor_total_amount: row.total_amount
              }
            })
          }
        />
      </Tooltip>
      <Tooltip
        placement="top"
        title={pdfDownloadingId === row._id ? t("Generating PDF...") : t("Download PDF")}
        arrow
      >
        <i
          className={`pe-7s-download btn-icon-wrapper text-success fs-5 p-1 ${pdfDownloadingId === row._id ? "opacity-50" : ""}`}
          style={{ cursor: pdfDownloadingId === row._id ? "not-allowed" : "pointer" }}
          onClick={() => pdfDownloadingId !== row._id && handleDownloadPdf(row)}
        />
      </Tooltip>
    </div>
  ) : null
}


  ];



  const handleSearch = (status) => {
    setFilterStatus(status);
    if (status !== '') {
      fetchDiscountcoupons(0, pageLimit, status)
    }
  };

  const handleClear = () => {
    setFilterStatus('');
    fetchDiscountcoupons(0, pageLimit);
  };
  const filteredItems = discountcoupons;


 

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <DiscountCouponsFilter
        onSearch={handleSearch}
        onClear={handleClear}
        filterStatus={filterStatus}
      />
    );
  }, [filterStatus]);


  function handlePageChange(page_index) {
    console.log("Page index:-", page_index)
    setCurrentPage(page_index)
    fetchDiscountcoupons(page_index, pageLimit, filterStatus);
  }

  async function handlePerRowsChange(newPageLimit, page_index) {
    setPageLimit(newPageLimit);
  }

  return (
    <Fragment>

      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="bg-light-gray bg-animation">
            <div className="d-flex justify-content-center align-items-center">
              <Col md="12" className="mx-auto app-login-box">
                <div className="app-page-title">
                  <div className="page-title-wrapper">
                    <div className="page-title-heading fw-bold">
                      <div className="page-title-icon">
                        <i className="pe-7s-news-paper icon-gradient bg-tempting-azure" />
                      </div>
                      <div>
                        {`${t("Service Provider Ledger")} ${t("Management")}`}
                        <div className="page-title-subheading">
                          {`${t("Service Provider Ledger Lists")}`}
                        </div>
                      </div>
                    </div>
                    <div className="page-title-actions">


                    </div>
                  </div>
                </div>
                <Row>
                  <LoadingOverlay
                    tag="div"
                    active={loading}
                    styles={{ overlay: (base) => ({ ...base }) }}
                    spinner={<DNALoader />}
                  >
                    <Col md="12">
                      <Card className="main-card mb-3">
                        <CardBody>
                          <Col md="6" style={{ float: "left", position: "absolute", zIndex: "1" }}>
                            {subHeaderComponentMemo}
                          </Col>
                          <DataTable
                            data={filteredItems}
                            columns={mycolumns}
                            pagination
                            fixedHeader
                            fixedHeaderScrollHeight="400px"
                            subHeader
                            subHeaderComponent={
                              <div>
                           <NavLink to="/withdrawl-requests">
                                <button
                                  type="button"
                                  className="btn btn-custom-color btn-hover-shine me-3 btn"
                                  onClick={handleToggleModalAddDiscountCoupon}
                                >
                                  {t('Total Withdrawl Request(s)')} : {withDrawlCount}
                                </button>
                           </NavLink>
                                  
                              </div>
                            }

                            paginationServer
                            paginationTotalRows={totalRows}
                            onChangePage={handlePageChange}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationResetDefaultPage={resetPaginationToggle}
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  </LoadingOverlay>
                </Row>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscountcouponsList;
